import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const useChatUnavailableModalState = () => {
  const $ = _c(6);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openChatUnavailableModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(false);
      window?.closeChatUnavailableCallback?.();
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeChatUnavailableModal = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      window.openChatUnavailableModal = openChatUnavailableModal;
      window.closeChatUnavailableModal = closeChatUnavailableModal;
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== isOpen) {
    t4 = {
      isOpen,
      open: openChatUnavailableModal,
      close: closeChatUnavailableModal
    };
    $[4] = isOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default useChatUnavailableModalState;